import { render, staticRenderFns } from "./edit-item.vue?vue&type=template&id=2d36ebba&scoped=true&"
import script from "./edit-item.vue?vue&type=script&lang=js&"
export * from "./edit-item.vue?vue&type=script&lang=js&"
import style0 from "./edit-item.vue?vue&type=style&index=0&id=2d36ebba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d36ebba",
  null
  
)

export default component.exports